import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import InstrumentIcon from "../../../components/instrument-icon";
import Big from "big.js";
import {useTranslation} from "react-i18next";
import FormButton from "../../../components/form-button";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import MATH_HELPER from "../../../helpers/math-helper";
import InformationToast from "../../../components/toast/InformationToast";
import SvgIcon from "../../../components/svg-icon";
import {decrypt, encrypt} from "../../../helpers/encryption";
import {useSearchParams} from "react-router-dom";
import InputMask from "react-input-mask";

const INITIAL_STATE = {
    amount: '',
    number: '',
    secret: '',
}
const RainModalContent = () => {
    const {
        lastChatLanguage,
        currencyList,
        currencies,
        selectedWallet,
        selectedFiat

    } = useSelector(state => state.authenticationReducer)

    const [step, setStep] = useState('form')
    const [searchParams, setSearchParams] = useSearchParams()
    const [rates, setRates] = useState({})
    useEffect(() => {

        if (selectedFiat) {
            const handleFiatRates = e => {
                const data = decrypt(e)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)
        }

    }, [selectedFiat])


    const [submitting, setSubmitting] = useState(false)
    const [enabled, setEnabled] = useState(false)
    const [currencyListFiltered, setCurrencyListFiltered] = useState([])
    const [search, setSearch] = useState('')
    const {t} = useTranslation()
    const [selectedCurrency, setSelectedCurrency] = useState({})

    useEffect(() => {
        setCurrencyListFiltered(currencyList?.filter(i => i.code?.toUpperCase().includes(search?.toUpperCase()) || i.name?.toUpperCase().includes(search?.toUpperCase())))
    }, [currencyList, search])

    useEffect(() => {
        handleChange('code', selectedCurrency?.code)
    }, [selectedCurrency])

    const handleChangeWallet = wall => {
        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setSelectedCurrency(wall)

        document.getElementById('modalWalet2')?.classList?.remove('show')
        document.getElementById('dropdown-menu-modal__network-menu-tip')?.classList?.remove('show')
        setSearch('')


    }

    useEffect(() => {
        if (selectedCurrency?.code) {
            const theWalletMe = currencyList.find(i => i.code === selectedCurrency?.code)
            setSelectedCurrency(theWalletMe)
        } else if (selectedWallet?.code) {
            const theWalletMe = currencyList.find(i => i.code === selectedWallet?.code)
            setSelectedCurrency(theWalletMe)
        }
    }, [selectedWallet])

    const [tipInstance, setTipInstance] = useState(INITIAL_STATE)


    useEffect(() => {
        setEnabled(parseFloat(selectedCurrency?.balance || 0) > 0 && parseFloat(tipInstance?.amount || 0) > 0 && parseFloat(tipInstance?.number || 0) > 0)
    }, [tipInstance, selectedCurrency?.balance])
    const handleTip = () => {

        if (!MATH_HELPER.isNumeric(tipInstance.amount) || !MATH_HELPER.isPositive(tipInstance.amount)) {
            // return toast.error(t(`general.enter-a-valid-amount`))
            return toast(<InformationToast
                icon={'ti-x'}
                message={t(`general.enter-a-valid-amount`)}
                title={t(`general.error`)}
            />)
        }

        if (!MATH_HELPER.isNumeric(tipInstance.number) || !MATH_HELPER.isNumeric(tipInstance.number)) {
            // return toast.error(t(`general.enter-a-valid-amount`))
            return toast(<InformationToast
                icon={'ti-x'}
                message={t(`general.enter-a-valid-number`)}
                title={t(`general.error`)}
            />)
        }

        setSubmitting(true)

        let amount = tipInstance.amount
        if (selectedFiat)
            amount = Big(tipInstance.amount || 0).times(rates[selectedCurrency?.code] || 0).toFixed(8)


        associateServices.rain({
            ...tipInstance,
            amount,
            code: selectedCurrency.code,
            language: lastChatLanguage ?? 'en'
        }).then(res => {

            setSubmitting(false)
            if (res?.status !== 200) {
                return toast(<InformationToast
                    icon={'ti-x'}
                    title={t(`general.error`)}
                    message={t(`api-notifications.${res?.errors}`)}
                />)
            }

            if (step === 'form') {
                if (res?.data?.step === 'email' || res?.data?.step === '2factor') {
                    setStep(res?.data?.step || '')
                    return handleChange('secret', res?.data?.secret)
                }
            }

            toast(<InformationToast
                icon={'ti-check'}
                title={t(`general.information`)}
                message={t(`api-notifications.rain-triggered`)}
            />)

            handleChange('amount', '')

            searchParams.delete('modal')
            setSearchParams(searchParams)
        })
    }
    const [regex] = useState(new RegExp("^\\d{1,8}(\\.\\d{0," + 8 + "})?$"))

    const handleChange = (type, value) => {
        if (type === 'amount') {
            value = value?.replace(/,/g, '.')
            if (value === '' || regex.test(value)) {
                setTipInstance(prevState => ({
                    ...prevState,
                    [type]: value
                }))
            }
        } else
            setTipInstance(prevState => ({
                ...prevState,
                [type]: value
            }))
    }

    const handleChangeNumber = (type, value) => {
        if (/^\d*$/.test(value)) { // Allows only digits
            handleChange(type, value);
        }

    }

    const [conversion, setConversion] = useState({code: '', conversion: ''})
    useEffect(() => {
        const handleFiatConversion = (e) => {
            const data = decrypt(e)

            setConversion({
                code: selectedWallet.code,
                conversion: data.results
            })

        }

        window?.tcpSocket?.emit('fiat:conversion', encrypt({
            currency: selectedCurrency?.code
        }))

        window?.tcpSocket?.on('fiat:conversions', handleFiatConversion)


    }, [selectedCurrency?.code])

    const getDisplayCurrency = () => {
        if (!selectedFiat)
            return `${Big(tipInstance?.amount || 0).toFixed(8)} ${selectedCurrency?.code}`


        return `${Big(tipInstance.amount || 0).times(rates[selectedCurrency?.code] || 0).toFixed(8)} ${selectedCurrency?.code}`
    }


    return (
        <>


            <div className="modal__form">

                {
                    step === 'form' ?

                        <>
                            <div className="dropdown modal__wallet-dropdown long">
                                <button
                                    className="modal__wallet-dropdown-btn"
                                    type="button"
                                    id="modalWalet2"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <div className="d-flex align-items-center gap-2">

                                        <InstrumentIcon code={selectedCurrency?.code}/>
                                        {Big(selectedCurrency?.balance || 0).toFixed(8)}
                                    </div>


                                    <SvgIcon id={'right-down'}/>
                                </button>
                                <div
                                    className="dropdown-menu modal__wallet-menu"
                                    aria-labelledby="modalWalet2"
                                    id="dropdown-menu-modal__network-menu-tip">
                                    <div className="modal__wallet-search">
                                        <div className="search">
                                            <input
                                                type="text"
                                                name="search"
                                                className="search__input"
                                                placeholder="Search currencies"
                                            />
                                        </div>
                                    </div>
                                    <ul className="modal__wallet-currencies">
                                        {
                                            currencyListFiltered?.map(wallet => (
                                                <li key={wallet?.code}
                                                    onClick={e => handleChangeWallet(wallet)}
                                                >
                                    <span>
                                        <InstrumentIcon code={wallet?.code}/>
                                        {wallet?.code}
                                    </span>
                                                    <span>{Big(wallet?.balance || 0).toFixed(8)}</span>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>

                            <div className="form__group">
                                <label htmlFor="" className="form__label">
                                    {t('rain.number')} <b>*</b>
                                </label>
                                <input
                                    value={tipInstance.number}
                                    onChange={e => handleChangeNumber('number', e.target.value)}
                                    type="number" className="form__input"/>
                            </div>

                            <div className="form__group">
                                <label htmlFor="" className="form__label form__label--max med">
                                    {t('rain.amount')} <b>*</b> <span>

                                    {getDisplayCurrency()}
                                </span>
                                </label>
                                <div className="form__amount">

                                    <input
                                        className="form__input"
                                        maxLength={24}
                                        type="number"
                                        value={tipInstance.amount || ''}
                                        onChange={e => handleChange('amount', e.target.value)}
                                    />

                                    <div className="form__coin">
                                        <InstrumentIcon code={selectedFiat || selectedCurrency?.code}/>
                                    </div>
                                    <button
                                        onClick={e => handleChange('amount', Big(selectedCurrency?.balance || 0).toFixed(8))}
                                        className="form__max" type="button">
                                        {t('rain.max')}
                                    </button>
                                </div>
                            </div>

                        </>
                        :
                        <>
                            <div className="form__group">
                                <label htmlFor="" className="form__label form__label--max med">
                                    {t('tip.amount')} <b>*</b>
                                    <span className="d-flex align-items-center gap-2">
                                    <InstrumentIcon code={selectedCurrency?.code}/>
                                        {getDisplayCurrency()}
                                    </span>
                                </label>

                            </div>
                            <div className="form__group">
                                <label htmlFor="" className="form__label">
                                    {t(`general.enter-otp-code-${step}`)} <b>*</b>
                                </label>
                                <InputMask
                                    mask={'999999'}
                                    maskPlaceholder={null}
                                    disabled={step === 'form'}
                                    className="form__input"
                                    value={tipInstance.otp || ''}
                                    onChange={e => handleChange('otp', e.target.value)}
                                    type="text" // Set type to text
                                    inputMode="numeric" // Hint for numeric keyboard
                                 />
                            </div>
                        </>

                }
                <FormButton
                    label={t('rain.button')}
                    loading={submitting}
                    disabled={!enabled}
                    onClick={handleTip}
                />

            </div>
        </>
    )

}


export default RainModalContent
